import { render } from "./ContactItem.vue?vue&type=template&id=7ab5791e"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__